export enum ApiButtonStatus {
  IDLE,
  IN_PROGRESS,
  COMPLETED,
  FAILED
}
